import React, {FC} from "react"
import styled from "styled-components"
import {H3} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import Roundel from "./Roundel"
import {RoundelProps} from "../containers/dummyData"

interface RoundelGridProps {
  roundels: RoundelProps[]
  title?: string
  roundelBackgroundColor?: string
}
export const RoundelGrid: FC<RoundelGridProps> = ({roundels, title, roundelBackgroundColor}) => {
  return (
    <OuterContainer className="container">
      <RoundelContainer>
        {title && <H3 textAlign="center">{title}</H3>}
        <div>
          <Flex justifyContent="center" wrap="wrap">
            {roundels.map((roundel, index) => (
              <div id={String(index)}>
                <Roundel
                  label={roundel.label}
                  imageUrl={roundel.imageUrl}
                  roundelBackgroundColor={roundelBackgroundColor}
                  link={roundel.link}
                />
              </div>
            ))}
          </Flex>
        </div>
      </RoundelContainer>
    </OuterContainer>
  )
}
const RoundelContainer = styled.div`
  padding: 28px 0 64px 0;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    padding: 48px 0 64px 0;
  `}
`

const OuterContainer = styled.div`
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    width: 1320px;
  `}
`
